




























import { Vue, Component, Watch } from "vue-property-decorator";
import moment from "moment";
@Component
export default class DateFilter extends Vue {
  private selectedView = "day";
  private viewFilter: Date[] = [new Date()];
  private customEnabled = false;

  private mounted() {
    this.changedView();
  }

  @Watch("selectedView")
  private changedView() {
    this.getDateOptions(moment());
  }

  @Watch("viewFilter")
  private changedFilters() {
    this.$emit("date-changed", this.viewFilter);
  }

  private getDateOptions(currentDate = moment()) {
    this.customEnabled = false;
    switch (this.selectedView.toLowerCase()) {
      case "day":
        this.viewFilter = [currentDate.toDate()];
        return;
      case "week":
        this.viewFilter = [currentDate.startOf("isoWeek").toDate(), currentDate.endOf("isoWeek").toDate()];
        return;
      case "month":
        this.viewFilter = [currentDate.startOf("month").toDate(), currentDate.endOf("month").toDate()];
        return;
      case "year":
        this.viewFilter = [currentDate.startOf("year").toDate(), currentDate.endOf("year").toDate()];
        return;
      case "custom":
        this.customEnabled = true;
        return;
      default:
        return;
    }
  }
  private findPrevious() {
    const current = moment(this.viewFilter[0]);
    switch (this.selectedView.toLowerCase()) {
      case "day":
        return this.getDateOptions(current.subtract(1, "d"));
      case "week":
        return this.getDateOptions(current.subtract(1, "w"));
      case "month":
        return this.getDateOptions(current.subtract(1, "month"));
      case "year":
        return this.getDateOptions(current.subtract(1, "y"));
      default:
        return this.getDateOptions(current);
    }
  }

  private findNext() {
    const current = moment(this.viewFilter[0]);
    switch (this.selectedView.toLowerCase()) {
      case "day":
        return this.getDateOptions(current.add(1, "d"));
      case "week":
        return this.getDateOptions(current.add(1, "w"));
      case "month":
        return this.getDateOptions(current.add(1, "month"));
      case "year":
        return this.getDateOptions(current.add(1, "y"));
      default:
        return this.getDateOptions(current);
    }
  }
}
